/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Properties
 * @export
 * @interface CampsiteGeoJSONProperties
 */
export interface CampsiteGeoJSONProperties {
    /**
     * Campsite ID
     * @type {string}
     * @memberof CampsiteGeoJSONProperties
     */
    campsiteId: string;
    /**
     * Name
     * @type {string}
     * @memberof CampsiteGeoJSONProperties
     */
    name: string;
}

/**
 * Check if a given object implements the CampsiteGeoJSONProperties interface.
 */
export function instanceOfCampsiteGeoJSONProperties(value: object): value is CampsiteGeoJSONProperties {
    if (!('campsiteId' in value) || value['campsiteId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CampsiteGeoJSONPropertiesFromJSON(json: any): CampsiteGeoJSONProperties {
    return CampsiteGeoJSONPropertiesFromJSONTyped(json, false);
}

export function CampsiteGeoJSONPropertiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): CampsiteGeoJSONProperties {
    if (json == null) {
        return json;
    }
    return {
        
        'campsiteId': json['campsite_id'],
        'name': json['name'],
    };
}

export function CampsiteGeoJSONPropertiesToJSON(value?: CampsiteGeoJSONProperties | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'campsite_id': value['campsiteId'],
        'name': value['name'],
    };
}

